<template>
  <div class="pay-dialog" v-if="visible">
    <div class="pay-dialog-mask" @click="handleClose"></div>
    <div class="pay-dialog-content">
      <div class="pay-dialog-header">
        <span>支付</span>
        <span class="close-btn" @click="handleClose">×</span>
      </div>
      <iframe 
        :srcdoc="payUrl"
        frameborder="0"
        width="300"
        height="600"
      ></iframe>
    </div>
  </div>
</template>

<script>
// Psocket 组件
import Psocket from '@/components/Flash/PSocket'
// 通讯协议
import Protocol from '@/common/scripts/protocol.js'
// 工具类
import EUY from '@/common/scripts/euy.js'

export default {
  name: 'OrderAliPay',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    payUrl: {
      type: String,
      required: true
    },
    orderId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      payStatusTimer: null
    }
  },
  methods: {
    handleClose() {
      this.stopCheckPayStatus()
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    // 开始轮询支付状态
    startCheckPayStatus() {
      // 清除可能存在的旧定时器
      this.stopCheckPayStatus()
      
      // 设置新的定时器，每5秒检查一次
      this.payStatusTimer = setInterval(() => {
        this.checkPayStatus()
      }, 5000)
    },
    // 停止支付状态轮询
    stopCheckPayStatus() {
      if (this.payStatusTimer) {
        clearInterval(this.payStatusTimer)
        this.payStatusTimer = null
      }
    },
    // 检查支付状态
    checkPayStatus() {
      let URL = process.env.HOST + '/api/storage/order/getPayStatus'
      let headers = {
        'Authorization': EUY.GetStorage('login_status').tokenId
      }
    
      let params = {
          'orderId': this.orderId
      }

      this.AJAX.get(URL, headers, params).then((res) => {
        if (res.code === 10000) {
          if (res.datas === 2) {
            // 支付成功
            this.stopCheckPayStatus()
            this.$emit('success')
            this.handleClose()
          } else if (res.datas !== 1) {
            // 支付失败或其他状态
            this.stopCheckPayStatus()
            this.$message.error('支付失败')
            this.handleClose()
          }
        }
      }).catch((error) => {
        console.error('检查支付状态失败:', error)
        this.$message.error('检查支付状态失败')
      })
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.startCheckPayStatus()
      } else {
        this.stopCheckPayStatus()
      }
    }
  },
  beforeDestroy() {
    this.stopCheckPayStatus()
  }
}
</script>

<style scoped>
.pay-dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
}

.pay-dialog .pay-dialog-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  cursor: pointer;
}

.pay-dialog .pay-dialog-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  border-radius: 4px;
  overflow: hidden;
}

.pay-dialog .pay-dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
}

.pay-dialog .pay-dialog-header .close-btn {
  cursor: pointer;
  font-size: 20px;
  color: #999;
}

.pay-dialog .pay-dialog-header .close-btn:hover {
  color: #666;
}
</style>



// WEBPACK FOOTER //
// OrderAliPay.vue?02ad3269